import { RoleTypes, RoleTypesTCX } from '../../helpers/enums';
import {
    marketInsightsRoutes,
    networkInsightsRoutes,
    publicRoutes,
    truckLoadRateRoutes
} from '../../routes/appRouteList';
import { AppRoles } from '../../interfaces/authorizationInterfaces';
import AuthService from '../../services/authService';

export const ROLES_REQUEST = 'ROLES_REQUEST';
export const ROLES_UPDATE = 'ROLES_UPDATE';
export const ROLES_RECEIVED = 'ROLES_RECEIVED';
export const SET_HOME_ROUTE = 'SET_HOME_ROUTE';
export const USER_UPDATE = 'USER_UPDATE';

const fetchAuthorizationStatus = (user: any) => {
    return async (dispatch: any): Promise<any> => {
        user.roles.forEach((element: string) => {
            switch (element) {
                case RoleTypesTCX.TruckLoadRateAdmin:
                    dispatch({
                        type: ROLES_UPDATE,
                        payload: {
                            [RoleTypes.TruckLoadRate]: true,
                            [RoleTypes.TruckLoadRateAdmin]: true,
                            [RoleTypes.NetworkInsights]: true
                        }
                    });
                    break;
                case RoleTypesTCX.TruckLoadRate:
                    dispatch({
                        type: ROLES_UPDATE,
                        payload: {
                            [RoleTypes.TruckLoadRate]: true,
                            [RoleTypes.NetworkInsights]: true
                        }
                    });
                    break;
                case RoleTypesTCX.MarketInsights:
                    dispatch({
                        type: ROLES_UPDATE,
                        payload: {
                            [RoleTypes.MarketInsights]: true,
                            [RoleTypes.NetworkInsights]: true
                        }
                    });
                    break;
                default:
            }
        });
    };
};

export const fetchUser = (): object => {
    return async (dispatch: any): Promise<any> => {
        const user = await AuthService.getUser();
        dispatch({
            type: USER_UPDATE,
            payload: user
        });
        await dispatch(fetchAuthorizationStatus(user));
    };
};

/**
 * This will return the home page route based on the roles the user has access to.
 * @param appRoles A list of AppRoles for the logged in user
 */
const getHomeRoute = (appRoles: AppRoles): object => {
    if (appRoles.marketInsights === true) {
        return {
            type: SET_HOME_ROUTE,
            payload: {
                homeRoute: marketInsightsRoutes.dashboard
            }
        };
    }

    if (appRoles.truckLoadRate === true) {
        return {
            type: SET_HOME_ROUTE,
            payload: {
                homeRoute: truckLoadRateRoutes.dataCharts
            }
        };
    }

    if (appRoles.networkInsights === true) {
        return {
            type: SET_HOME_ROUTE,
            payload: {
                homeRoute: networkInsightsRoutes.geography
            }
        };
    }

    return {
        type: SET_HOME_ROUTE,
        payload: {
            homeRoute: publicRoutes.notAuthorized
        }
    };
};

export const fetchRoles = (): object => {
    return async (dispatch: Function, getState: Function): Promise<any> => {
        dispatch({ type: ROLES_REQUEST });

        await dispatch(fetchUser());

        const { roles } = getState().userDetails;
        dispatch(getHomeRoute(roles));
        dispatch({
            type: ROLES_RECEIVED
        });
    };
};
